import { createApi } from "@reduxjs/toolkit/query/react"
import { baseQueryWithReauth } from "../../app/utils"
import { Feature } from "@prisma/client"

export const featureApi = createApi({
  reducerPath: "featureApi",
  baseQuery: baseQueryWithReauth({ baseUrl: "/api/" }),
  endpoints: builder => ({
    getFeatures: builder.query<Feature[], void>({
      query: () => "features",
    }),
  }),
})

export const { useGetFeaturesQuery } = featureApi
